import ScientificCouncilExportModal from "./ScientificCouncilExportModal";

export default ScientificCouncilExportModal;

